import React from 'react'
import { connect } from 'react-redux'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'

const CreateCommission = ({ dispatch }) => {
    const submitFX = (formData, formId) => {
        console.log('submit the form')
    }

    const successFX = (commissionId) => {
        console.log('created a commission')
    }

    return (
        <div>
            <h1>Create a Commission</h1>
            <SHSForm submitFX={submitFX} successFX={successFX}>
                <InputElement
                    type="text"
                    id="amount"
                    label="Commission Amount"
                    required />
            </SHSForm>
        </div>
    )
}

export default connect()(CreateCommission)
